import api from '../../../services/api';
import { useState, useEffect } from "react";
import { Bar } from 'react-chartjs-2';  // Importando o gráfico de barras
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels'; // Importar o plugin de datalabels
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import PageContainer from '../../../common/components/PageContainer';
import PageHeader from '../../../common/components/PageHeader';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ChartDataLabels // Registrar o plugin
);

function RelatorioVeiculo() {
    const [abastecimentos, setAbastecimentos] = useState([]); 
    const [trocasOleo, setTrocasOleo] = useState([]);
    const [manutencoes, setManutencoes] = useState([]);
    const [mesSelecionado, setMesSelecionado] = useState(new Date().getMonth() + 1); // Mês atual
    const [anoSelecionado, setAnoSelecionado] = useState(new Date().getFullYear());  // Ano atual

    const meses = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await api.get('/relatorio/veiculo');
                setAbastecimentos(response.data.abastecimentos);
                setManutencoes(response.data.manutencoes);
                setTrocasOleo(response.data.trocasOleo);
            } catch (error) {
                console.error('Erro ao gerar os gráficos', error);
            }
        }

        fetchData();
    }, []);

    const filtrarPorMesEAno = (dados) => {
        return dados.filter(item => {
            const data = new Date(item.data);
            return data.getMonth() + 1 === parseInt(mesSelecionado) && data.getFullYear() === parseInt(anoSelecionado);
        });
    };

    const abastecimentosFiltrados = filtrarPorMesEAno(abastecimentos);
    const manutencoesFiltradas = filtrarPorMesEAno(manutencoes);
    const trocasOleoFiltradas = filtrarPorMesEAno(trocasOleo);

    const veiculoAbastecimentos = {};
    abastecimentosFiltrados.forEach(abastecimento => {
        const placa = abastecimento.veiculo.placa;
        if (!veiculoAbastecimentos[placa]) {
            veiculoAbastecimentos[placa] = 0;
        }
        veiculoAbastecimentos[placa] += abastecimento.litros;
    });

    
    const veiculoManutencoes = {};
    manutencoesFiltradas.forEach(manutencao => {
        const placa = manutencao.veiculo.placa;
        if (!veiculoManutencoes[placa]) {
            veiculoManutencoes[placa] = 0;
        }
        veiculoManutencoes[placa] += manutencao.valor;
    });

    
    const veiculoTrocasOleo = {};
    trocasOleoFiltradas.forEach(trocaOleo => {
        const placa = trocaOleo.veiculo.placa;
        if (!veiculoTrocasOleo[placa]) {
            veiculoTrocasOleo[placa] = 0;
        }
        veiculoTrocasOleo[placa] += trocaOleo.valor;
    });

    
    const dataAbastecimentos = {
        labels: Object.keys(veiculoAbastecimentos),
        datasets: [
            {
                label: 'Litros Abastecidos',
                data: Object.values(veiculoAbastecimentos),
                backgroundColor: 'rgba(76, 175, 80, 0.2)',
                borderColor: 'rgba(66, 128, 69, 1)',
                borderWidth: 1
            }
        ]
    };

    const dataManutencoes = {
        labels: Object.keys(veiculoManutencoes),
        datasets: [
            {
                label: 'Valor de Manutenção (R$)',
                data: Object.values(veiculoManutencoes),
                backgroundColor: 'rgba(33, 150, 243, 0.2)',
                borderColor: 'rgba(47, 117, 173, 1)',
                borderWidth: 1
            }
        ]
    };

    const dataTrocasOleo = {
        labels: Object.keys(veiculoTrocasOleo),
        datasets: [
            {
                label: 'Valor de Troca de Óleo (R$)',
                data: Object.values(veiculoTrocasOleo),
                backgroundColor: 'rgba(255, 152, 0, 0.2)',
                borderColor: 'rgba(194, 126, 25, 1)',
                borderWidth: 1
            }
        ]
    };

    const optionsAbastecimento = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `Relatório de litros abastecidos em ${meses[mesSelecionado - 1]} de ${anoSelecionado}`,
            },
            datalabels: {
                anchor: 'end',
                align: 'top',
                offset: -5,
                color: 'black',
                font: {
                    weight: 'bold'
                },
                formatter: function(value) {
                    return value
                }
            }
        },
    };

    const optionsManutencao = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `Relatório de manutenções em ${meses[mesSelecionado - 1]} de ${anoSelecionado}`,
            },
            datalabels: {
                anchor: 'end',
                align: 'top',
                offset: -5,
                color: 'black',
                font: {
                    weight: 'bold'
                },
                formatter: function(value) {
                    return `R$ ${value.toFixed(2).replace('.', ',')}`;
                }
            }
        },
    };

    const optionsTrocaOleo = {
        responsive: true,
        plugins: {
            legend: {
                position: 'top',
            },
            title: {
                display: true,
                text: `Relatório de trocas de óleo em ${meses[mesSelecionado - 1]} de ${anoSelecionado}`,
            },
            datalabels: {
                anchor: 'end',
                align: 'top',
                offset: -5,
                color: 'black',
                font: {
                    weight: 'bold'
                },
                formatter: function(value) {
                    return `R$ ${value.toFixed(2).replace('.', ',')}`;
                }
            }
        },
    };

    const handleMesChange = (e) => {
        setMesSelecionado(parseInt(e.target.value));
    };

    const handleAnoChange = (e) => {
        setAnoSelecionado(parseInt(e.target.value));
    };

    return (
        <PageContainer>
            <PageHeader title="Relatório de Veículos">
                <Stack direction="row" spacing={1}>
                    <Select size="small" value={mesSelecionado} onChange={handleMesChange}>
                        {meses.map((mes, index) => (
                            <MenuItem key={index + 1} value={index + 1}>{mes}</MenuItem>
                        ))}
                    </Select>
                    <Select size="small" value={anoSelecionado} onChange={handleAnoChange}>
                        {[2024, 2025].map(ano => (
                            <MenuItem key={ano} value={ano}>{ano}</MenuItem>
                        ))}
                    </Select>
                </Stack>
            </PageHeader>

            <Stack spacing={2}>
                <Card>
                    <CardContent>
                        {abastecimentosFiltrados.length > 0 ? (
                            <Bar data={dataAbastecimentos} options={optionsAbastecimento} />
                        ) : (
                            <Typography color="text.secondary">Não existem dados de abastecimento para o período selecionado.</Typography>
                        )}
                    </CardContent>
                </Card>

                <Card>
                    <CardContent>
                        {manutencoesFiltradas.length > 0 ? (
                            <Bar data={dataManutencoes} options={optionsManutencao} />
                        ) : (
                            <Typography color="text.secondary">Não existem dados de manutenção para o período selecionado.</Typography>
                        )}
                    </CardContent>
                </Card>

                <Card>
                    <CardContent>
                        {trocasOleoFiltradas.length > 0 ? (
                            <Bar data={dataTrocasOleo} options={optionsTrocaOleo} />
                        ) : (
                            <Typography color="text.secondary">Não existem dados de troca de óleo para o período selecionado.</Typography>
                        )}
                    </CardContent>
                </Card>
            </Stack>
        </PageContainer>
    );
}

export default RelatorioVeiculo;
